import React from 'react'

const Explore = () => {
    return (
            <div className="mainside">
        <div className="container">
        <div>
            Explore
        </div>
        </div>
        </div>
    )
}

export default Explore
